import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router/src/utils/preactivation';
import { Router } from '@angular/router';
import { CacheService } from './cache.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  path;
  route;
  constructor(private router: Router, private auth: AuthService){  }
  
  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.auth.getCurrentUser()
      .then(() => {
          return resolve(true);
        }, () => {
          this.router.navigate(['login']);
          return resolve(false);
        })
    });
  }
}
